import React from 'react'

export default function FormButtons ({ children }) {
  return (
    <div className='form-buttons'>
      {children}
    </div>
  )
}
